<template>
  <div class="container-fluid" style>
    <share-modal v-if="isBrowser" ref="shareModal"></share-modal>

    <!-- <header-box ref="header"></header-box> -->
    <div class="main">
      <div>
        <ul class="content" ref="itemList" id="listgroup-ex">
          <li>
            <header-box ref="header"></header-box>
          </li>
          <li>
            <about-banner></about-banner>
          </li>
          <li id="culture">
            <div class="container">
              <h1 class="title"><span class="left-divider"></span> 企业文化</h1>
              <div class="txt">
                掌上公交一直秉承“和谐共生，发展创新”的宗旨，努力致力于“移动物联、智慧交通”领域，打造国民出行服务平台，以“移动改变生活，出行即是服务（MaaS）”的发展理念，积极通过多种交通方式一站式服务，改善公共出行体验。
              </div>
              <div class="txt">
                未来掌上公交将继续在交通出行服务商努力为人民的便民服务贡献更大的力量！
              </div>
            </div>
          </li>
          <li id="value">
            <div class="container">
              <h1 class="title"><span class="left-divider"></span> 价值观</h1>
              <img
                class="img-responsive"
                src="../../assets/images/WechatIMG392.png"
                alt
              />
            </div>
          </li>
          <li id="join">
            <div class="container">
              <h1 class="title"><span class="left-divider"> </span>办公环境</h1>
              <div class="office-box">
                <img
                  class="img-responsive office-01"
                  src="../../assets/images/office-01.png"
                  alt=""
                />
                <div class="grid-center">
                  <img
                    class="img-responsive office-02"
                    src="../../assets/images/office-02.png"
                    alt=""
                  />
                  <img
                    class="img-responsive office-03"
                    src="../../assets/images/office-03.png"
                    alt=""
                  />
                </div>

                <img
                  class="img-responsive office-04"
                  src="../../assets/images/office-04.png"
                  alt=""
                />
                <img
                  class="img-responsive office-05"
                  src="../../assets/images/office-05.png"
                  alt=""
                />
                <img
                  class="img-responsive office-06 grid-center"
                  src="../../assets/images/office-06.png"
                  alt=""
                />
                <div>
                  <img
                    class="img-responsive office-07"
                    src="../../assets/images/office-07.png"
                    alt=""
                  />

                  <img
                    class="img-responsive office-08"
                    src="../../assets/images/office-08.png"
                    alt=""
                  />
                </div>
              </div>
              <div>
                <p>更多招聘动态，请关注我们：</p>
                <button @click="jump" class="join-us btn">
                  <span>+</span> 加 入 我 们
                </button>
              </div>
            </div>
          </li>
          <!-- <li id="join">
            <div class="container"></div>
          </li> -->

          <li>
            <footer-box></footer-box>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBox from "components/header/header";
import FooterBox from "components/footer/footer";
import AboutBanner from "components/banner/about.banner";
import ShareModal from "components/sharemodal/sharemodal";

export default {
  data() {
    return {
      items: [
        {
          tag: "2019-02-12",
          type: "circle",
          content: "测试内容",
        },
        {
          tag: "2019-02-13",
          type: "circle",
          content: "练习内容",
        },
      ],
      isBrowser: false,
    };
  },
  components: {
    HeaderBox,
    FooterBox,
    AboutBanner,
    ShareModal,
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
    });
  },

  methods: {
    jump() {
      window.open(
        `https://www.zhipin.com/gongsi/f1e76c07ff84e2ab0Hd-3d-0EQ~~.html?ka=search_rcmd_company_f1e76c07ff84e2ab0Hd-3d-0EQ~~_custompage`
      );
    },
  },
};
</script>

<style lang="less" scoped>
@import "./joinus.less";
</style>



// WEBPACK FOOTER //
// src/components/joinus/joinus.vue